import React from "react";
import { Link } from "@quintype/components";
import { string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { Facebook, Twitter } from "../../../atoms/icons/StoryPageIcons";
import Instagram from "./Instagram";
import LinkedIn from "./LinkedIn";
import KiaLogo from "../../../atoms/icons/kia-logo";
import { logoRenderer } from "../../../utils/react-utils";

import { getSocialLinks } from "../../../utils/utils";

import "./kishoraloFooter.m.css";

const KishoraloFooterBase = ({ currentPath }) => {
  const socialLinks = getSocialLinks("kishoralo");

  return (
    <div styleName="kishoralo-footer">
      <div styleName="social-links">
        <div styleName="first-three-icons">
          <Link href={socialLinks.fbUrl}>
            <Facebook color1="#001246" color2="#ffffff" />
          </Link>
          <Link href={socialLinks.twitterUrl}>
            <Twitter color1="#001246" color2="#ffffff" />
          </Link>
          <Link href={socialLinks.InstagramUrl}>
            <Instagram color1="#001246" color2="#ffffff" />
          </Link>
        </div>
        <div>
          <Link href={socialLinks.LinkedInUrl}>
            <LinkedIn color1="#001246" color2="#ffffff" />
          </Link>
        </div>
      </div>
      <div styleName="footer-details">
        <div styleName="logo">{logoRenderer(<KiaLogo />, currentPath)}</div>
        <div styleName="address">
          <span className="line-1">কিশোর আলো</span>
          <span className="line-2">প্রগতি ইনস্যুরেন্স ভবন</span>
          <span className="line-3">২০-২১ কারওয়ান বাজার , ঢাকা ১২১৫</span>
          <span className="line-4">ফোন : ৮১৮০০৭৮-৮১। ফ্যাক্স : ৯১২১০৫২।</span>
          <span className="line-5">
            ই-মেইল: <a href="mailto:editor@kishoralo.com">editor@kishoralo.com</a>
          </span>
        </div>
        <div styleName="publisher">
          <span className="line-1">প্রকাশক : মতিউর রহমান</span>
          <span className="line-1">সম্পাদক : আনিসুল হক</span>
          <span className="line-1">সহসম্পাদক : আদনান মুকিত, মহিতুল আলম</span>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    currentPath: get(state, ["currentPathReducer", "currentPath"], null)
  };
}

KishoraloFooterBase.propTypes = {
  currentPath: string
};

export const KishoraloFooter = connect(mapStateToProps)(KishoraloFooterBase);

export default KishoraloFooter;
